export const awsConfig = {
  Auth: {
    region: import.meta.env.VITE_COGNITO_USER_POOL_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    userPoolWebClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
  },
};

export const ApiConfig = {
  ControllerBaseUrl: import.meta.env.VITE_AWS_SERVICE_ENDPOINT,
  ApibelBaseUrl: import.meta.env.VITE_AWS_APIBEL_SERVICE_ENDPOINT,
};

export const signUpConfig = {
  header: "CertCrowd Sign Up",
  hideAllDefaults: true,
  defaultCountryCode: "1",
  signUpFields: [
    {
      label: "Email",
      key: "email",
      required: true,
      displayOrder: 1,
      type: "string",
    },
    {
      label: "Password",
      key: "password",
      required: true,
      displayOrder: 2,
      type: "password",
    },
    {
      label: "Given Name",
      key: "given_name",
      required: true,
      displayOrder: 3,
      type: "string",
    },
    {
      label: "Family Name",
      key: "family_name",
      required: true,
      displayOrder: 4,
      type: "string",
    },
  ],
};
